import '../styles/app.less';
import * as React from "react";
import * as ReactDOM from "react-dom";
import DevTools from "mobx-react-devtools";
import { AppStore } from "./Stores/AppStore";
import { AppRoutes } from './Routes';
import { HashRouter } from "react-router-dom";

AppStore.init().then(() => {
	const appElem = document.getElementById('app') as HTMLElement;
	const devtoolsElem = document.getElementById('devtools') as HTMLElement;
	if (AppStore.context.sessionDetails.isApp && !AppStore.context.sessionDetails.isDebuggerAttached) {
		appElem.oncontextmenu = () => { return false };
	}
	ReactDOM.render(
		<HashRouter>
			<AppRoutes></AppRoutes>
		</HashRouter>, appElem);

	const position = { left: "100" };

	ReactDOM.render(<DevTools position={position} />, devtoolsElem);
});
